<template>
  <Dialog :open="state.open" @update:open="handleClose">
    <DialogContent class="rounded-lg z-[100]" overlay-class="z-[100]" hide-close @interact-outside.prevent="() => {}">
      <DialogHeader class="text-left space-y-4">
        <DialogTitle class="text-2xl">{{ state.title }}</DialogTitle>
        <DialogDescription class="text-foreground text-sm">{{ state.description }}</DialogDescription>
      </DialogHeader>

      <form v-if="state.open" class="space-y-4" :validate-on-mount="false" @submit="onFormSubmit">
        <FormField v-if="state.requireConfirmation" name="items" :validate-on-mount="false">
          <FormItem class="mt-4 mb-8">
            <FormField v-slot="{ value, handleChange }" type="checkbox" value="checked" :unchecked-value="false" name="items">
              <FormItem class="flex flex-row items-start space-x-3 space-y-0.5">
                <FormControl>
                  <Checkbox :model-value="value.includes('checked')" @update:model-value="handleChange" />
                </FormControl>
                <FormLabel class="font-normal"> {{ state.confirmText }} </FormLabel>
              </FormItem>
            </FormField>
            <FormMessage />
          </FormItem>
        </FormField>

        <DialogFooter>
          <DialogClose type="button" :as="Button" variant="secondary" class="mr-auto">
            {{ state.cancelText }}
          </DialogClose>
          <Button type="submit" :variant="state.variant">{{ state.submitText }}</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts" generic="T">
import { toTypedSchema } from '@vee-validate/zod'
import * as z from 'zod'
import { useForm } from 'vee-validate'
import { Button } from '#components'

const { state, submit } = useConfirmation()

const formSchema = toTypedSchema(
  z.object({
    items: z.array(z.string()).refine(value => !state.value.requireConfirmation || value.some(item => item), {
      message: 'You must confirm this action',
    }),
  }),
)

function handleClose(open: boolean) {
  if (!open) {
    submit(false)
  }
  resetForm()
}

const { handleSubmit, resetForm } = useForm({
  validationSchema: formSchema,
  initialValues: {
    items: [],
  },
  validateOnMount: false,
})

const onFormSubmit = handleSubmit(async () => {
  submit(true)
  resetForm()
})
</script>
